"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreferenceList = exports.StyledList = void 0;

var _reactHooks = require("@trycourier/react-hooks");

var _reactProvider = require("@trycourier/react-provider");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PreferenceTemplate = require("./PreferenceTemplate");

var _PreferencesV = require("./PreferencesV4");

var StyledList = _styledComponents["default"].div.withConfig({
  displayName: "PreferenceList__StyledList",
  componentId: "sc-14ehsz3-0"
})(["overflow:scroll;display:flex;height:433px;flex-direction:column;background:var(--ci-background);"]);

exports.StyledList = StyledList;

var PreferenceV4Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "PreferenceList__PreferenceV4Wrapper",
  componentId: "sc-14ehsz3-1"
})(["padding:0 10px;"]);

var PreferenceList = function PreferenceList(_ref) {
  var theme = _ref.theme,
      draft = _ref.draft;
  var courierContext = (0, _reactProvider.useCourier)();
  var preferences = (0, _reactHooks.usePreferences)();
  (0, _react.useEffect)(function () {
    preferences.fetchRecipientPreferences(courierContext.tenantId);
    preferences.fetchPreferencePage(courierContext.tenantId, draft);
  }, []);

  var renderPreferences = function renderPreferences() {
    var _preferences$preferen, _preferences$preferen2, _preferences$preferen3, _preferences$preferen4, _preferences$preferen5, _preferences$preferen6, _preferences$preferen7, _preferences$preferen8, _preferences$preferen9, _preferences$preferen10;

    if (!((_preferences$preferen = preferences.preferencePage) !== null && _preferences$preferen !== void 0 && (_preferences$preferen2 = _preferences$preferen.sections) !== null && _preferences$preferen2 !== void 0 && _preferences$preferen2.nodes.length)) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }

    if ((_preferences$preferen3 = preferences.preferencePage) !== null && _preferences$preferen3 !== void 0 && (_preferences$preferen4 = _preferences$preferen3.sections) !== null && _preferences$preferen4 !== void 0 && _preferences$preferen4.nodes && ((_preferences$preferen5 = preferences.preferencePage) === null || _preferences$preferen5 === void 0 ? void 0 : (_preferences$preferen6 = _preferences$preferen5.sections) === null || _preferences$preferen6 === void 0 ? void 0 : _preferences$preferen6.nodes.length) > 0) {
      return /*#__PURE__*/_react["default"].createElement(PreferenceV4Wrapper, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_PreferencesV.PreferencesV4, {
        tenantId: courierContext.tenantId,
        draft: draft
      }));
    } // TODO: Handle Backfilled preferences. (https://linear.app/trycourier/issue/C-6836/cleanup-react-preference-section-template-renderer-after-backfill)


    if (!((_preferences$preferen7 = preferences.preferencePage) !== null && _preferences$preferen7 !== void 0 && (_preferences$preferen8 = _preferences$preferen7.sections) !== null && _preferences$preferen8 !== void 0 && _preferences$preferen8.nodes) || ((_preferences$preferen9 = preferences.preferencePage) === null || _preferences$preferen9 === void 0 ? void 0 : (_preferences$preferen10 = _preferences$preferen9.sections) === null || _preferences$preferen10 === void 0 ? void 0 : _preferences$preferen10.nodes.length) < 1) {
      var _courierContext$brand, _courierContext$brand2;

      return (_courierContext$brand = courierContext.brand) === null || _courierContext$brand === void 0 ? void 0 : (_courierContext$brand2 = _courierContext$brand.preferenceTemplates) === null || _courierContext$brand2 === void 0 ? void 0 : _courierContext$brand2.map(function (template) {
        var _preferences$recipien;

        return /*#__PURE__*/_react["default"].createElement(_PreferenceTemplate.PreferenceTemplate, {
          key: template.templateId,
          preferenceTemplate: template,
          recipientPreference: preferences === null || preferences === void 0 ? void 0 : (_preferences$recipien = preferences.recipientPreferences) === null || _preferences$recipien === void 0 ? void 0 : _preferences$recipien.find(function (preference) {
            return preference.templateId === template.templateId;
          }),
          routingOptions: ["direct_message", "email", "push"]
        });
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledList, null, renderPreferences()));
};

exports.PreferenceList = PreferenceList;